import TemplateButton from 'components/Buttons/TemplateButton';
import ErrorToggleButton from 'components/Buttons/ErrorToggleButton';
import { faXmark } from '@fortawesome/pro-duotone-svg-icons';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { useRef, useEffect } from 'react';
import { useInOutTransition } from 'hooks';
import './TemplateValidationErrors.scss';

interface Props {
    render: boolean,
    toggleRender: boolean,
    content: string[],
    message: string,
    dismissCallback: () => void,
    toggleErrors: () => void,
    onRowClick?: (rowIndex: number) => void;
}

export default function TemplateValidationErrors({ render, toggleRender, content, message, dismissCallback, toggleErrors, onRowClick }: Props) {
    
    const { isActive, isNotTransitionedOut } = useInOutTransition(render),
          panelContent = useRef<string[] | null>(null);

    if (!isActive) {
        panelContent.current = content;
    }

    const localCopy: string[] = [...panelContent.current ?? []],
          title = localCopy.shift();

    return (isNotTransitionedOut && (
        <>
            <div className={`validationErrorsPanel ${render && isActive ? "" : "hidden"}`} data-testid="validationErrorsPanel">
            <p>{"Unable to validate the Excel template." +
                ((panelContent.current && panelContent.current.length > 0) ? "  See below for more details." : "")}
            </p>
            <div hidden={!panelContent.current || panelContent.current.length === 0}>
                <p>{title}</p>
                <ul>
                    {localCopy
                        // filter out junk lines (like stray zeros or empty strings)
                        .filter(line => line && line.trim() !== '' && line.trim() !== '0')
                            .map((errorString, index) => {
                            const match = errorString.match(/Data\s+row\s+(\d+)/i);
                            const rowNumber = match ? parseInt(match[1], 10) : null;

                            return (
                                <li key={`errorString${index}`}>
                                    {rowNumber && onRowClick ? (
                                        <button
                                            type="button"
                                            className="errorRowLink"
                                            onClick={() => onRowClick(rowNumber)}
                                        >
                                            {errorString}
                                        </button>
                                    ) : (
                                        errorString
                                    )}
                                </li>
                            );
                        })}
                </ul>
            </div>
            <p id="validationCorrectionMessage">{message}</p>
                <TemplateButton text="Close" btnIcon={faXmark} onClick={dismissCallback}></TemplateButton>
            </div>
            {toggleRender && (
                <ErrorToggleButton btnIcon={faTriangleExclamation} onClick={toggleErrors}></ErrorToggleButton>
            )}
        </>
    ));
}
